import React from "react";

const Subjects = () => {
    return (
        <React.Fragment>
            Sub
        </React.Fragment>
    )
}

export default Subjects